import styled from '@emotion/styled';
import { NakedButton, Icon, Text } from 'roo-ui/components';

const InlineFlexButton = styled(NakedButton)`
  display: inline-flex;
  align-items: center;
  font-weight: normal;
`;

export const EditButtonWithIcon = (props) => (
  <InlineFlexButton color="brand.primary" {...props} aria-label="Edit Details Button">
    <Text fontSize="base">Edit Details</Text>
    <Icon name="modeEdit" title="Edit Details" size={18} ml={1} />
  </InlineFlexButton>
);
